import { render, staticRenderFns } from "./Asignacion_Usuarios.vue?vue&type=template&id=45b7f75a&scoped=true"
import script from "./Asignacion_Usuarios.vue?vue&type=script&lang=js"
export * from "./Asignacion_Usuarios.vue?vue&type=script&lang=js"
import style0 from "./Asignacion_Usuarios.vue?vue&type=style&index=0&id=45b7f75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7f75a",
  null
  
)

export default component.exports